export const workoutPlans = {
  beginner: {
    traditional: 
    `
    <div class="workout-program">
    <h2>Beginner Bodybuilding with Mike Mentzer Method (3 Days a Week)</h2>

    <!-- Day 1 -->
    <h3>Day 1: Upper Body</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (5-10 minutes)</strong></td>
            </tr>
            <tr>
                <td>Light cardio, Dynamic stretches</td>
                <td>-</td>
                <td>5-10 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Bench Press</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Bent-Over Rows</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Overhead Dumbbell Press</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Pull-Ups or Lat Pulldowns</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Tricep Dips</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Bicep Curls</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
        </tbody>
    </table>

    <!-- Day 2 -->
    <h3>Day 2: Lower Body</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (5-10 minutes)</strong></td>
            </tr>
            <tr>
                <td>Light cardio, Dynamic stretches</td>
                <td>-</td>
                <td>5-10 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Squats</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Deadlifts</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Leg Press</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Leg Curls</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Calf Raises</td>
                <td>3</td>
                <td>10-15 reps</td>
                <td>60-90 secs</td>
            </tr>
        </tbody>
    </table>

    <!-- Day 3 -->
    <h3>Day 3: Full Body</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (5-10 minutes)</strong></td>
            </tr>
            <tr>
                <td>Light cardio, Dynamic stretches</td>
                <td>-</td>
                <td>5-10 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Incline Dumbbell Press</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Seated Cable Rows</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Lunges</td>
                <td>3</td>
                <td>8-12 reps per leg</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Shoulder Lateral Raises</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Plank</td>
                <td>3</td>
                <td>30-60 secs</td>
                <td>60-90 secs</td>
            </tr>
        </tbody>
    </table>

    <h3>Additional Notes</h3>
    <ul>
        <li><strong>Progressive Overload:</strong> Increase weights as you gain strength while maintaining form.</li>
        <li><strong>Rest Days:</strong> Ensure at least one rest day between workouts for recovery.</li>
        <li><strong>Cool Down:</strong> End each session with static stretching.</li>
    </ul>
</div>

    
    `,


    split: `

    <div class="workout-program">
    <h2>Beginner Split Training with Mike Mentzer Method (3 Days a Week)</h2>

    <!-- Day 1 -->
    <h3>Day 1: Push (Chest, Shoulders, Triceps)</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (5-10 minutes)</strong></td>
            </tr>
            <tr>
                <td>Light cardio, Dynamic stretches</td>
                <td>-</td>
                <td>5-10 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Bench Press</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Incline Dumbbell Press</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Overhead Dumbbell Press</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Lateral Raises</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Tricep Dips</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Skull Crushers</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
        </tbody>
    </table>

    <!-- Day 2 -->
    <h3>Day 2: Pull (Back, Biceps)</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (5-10 minutes)</strong></td>
            </tr>
            <tr>
                <td>Light cardio, Dynamic stretches</td>
                <td>-</td>
                <td>5-10 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Pull-Ups or Lat Pulldowns</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Bent-Over Rows</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Seated Cable Rows</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Face Pulls</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Bicep Curls</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Hammer Curls</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
        </tbody>
    </table>

    <!-- Day 3 -->
    <h3>Day 3: Legs</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (5-10 minutes)</strong></td>
            </tr>
            <tr>
                <td>Light cardio, Dynamic stretches</td>
                <td>-</td>
                <td>5-10 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Squats</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Deadlifts</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Leg Press</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Leg Curls</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Calf Raises</td>
                <td>3</td>
                <td>10-15 reps</td>
                <td>60-90 secs</td>
            </tr>
        </tbody>
    </table>

    <h3>Additional Notes</h3>
    <ul>
        <li><strong>Progressive Overload:</strong> Increase weights as you gain strength while maintaining form.</li>
        <li><strong>Rest Days:</strong> Ensure at least one rest day between workouts for recovery.</li>
        <li><strong>Cool Down:</strong> End each session with static stretching.</li>
    </ul>
</div>

    
    `,
    pyramid: 
    `
    
    <div class="workout-program">
    <h2>Beginner Pyramid Training with Mike Mentzer Method (3 Days a Week)</h2>

    <!-- Day 1 -->
    <h3>Day 1: Upper Body</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (5-10 minutes)</strong></td>
            </tr>
            <tr>
                <td>Light cardio, Dynamic stretches</td>
                <td>-</td>
                <td>5-10 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Bench Press</td>
                <td>4</td>
                <td>12, 10, 8, 6</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Bent-Over Rows</td>
                <td>4</td>
                <td>12, 10, 8, 6</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Overhead Dumbbell Press</td>
                <td>4</td>
                <td>12, 10, 8, 6</td>
                <td>60-90 secs</td>
            </tr>
        </tbody>
    </table>

    <!-- Day 2 -->
    <h3>Day 2: Lower Body</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (5-10 minutes)</strong></td>
            </tr>
            <tr>
                <td>Light cardio, Dynamic stretches</td>
                <td>-</td>
                <td>5-10 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Squats</td>
                <td>4</td>
                <td>12, 10, 8, 6</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Deadlifts</td>
                <td>4</td>
                <td>12, 10, 8, 6</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Leg Press</td>
                <td>4</td>
                <td>12, 10, 8, 6</td>
                <td>60-90 secs</td>
            </tr>
        </tbody>
    </table>

    <!-- Day 3 -->
    <h3>Day 3: Full Body</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (5-10 minutes)</strong></td>
            </tr>
            <tr>
                <td>Light cardio, Dynamic stretches</td>
                <td>-</td>
                <td>5-10 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Incline Dumbbell Press</td>
                <td>4</td>
                <td>12, 10, 8, 6</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Pull-Ups or Lat Pulldowns</td>
                <td>4</td>
                <td>12, 10, 8, 6</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Leg Curls</td>
                <td>4</td>
                <td>12, 10, 8, 6</td>
                <td>60-90 secs</td>
            </tr>
        </tbody>
    </table>

    <h3>Additional Notes</h3>
    <ul>
        <li><strong>Progressive Overload:</strong> Gradually increase weights as you become stronger while maintaining proper form.</li>
        <li><strong>Rest Days:</strong> Ensure at least one day of rest between workouts for recovery.</li>
        <li><strong>Cool Down:</strong> End each session with static stretching to improve flexibility and reduce muscle soreness.</li>
    </ul>
</div>

    
    `,

    superset: 
    `
    
    <div class="workout-program">
    <h2>Beginner Superset Training with Mike Mentzer Method (3 Days a Week)</h2>

    <!-- Day 1 -->
    <h3>Day 1: Upper Body (Superset Push and Pull)</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (5-10 minutes)</strong></td>
            </tr>
            <tr>
                <td>Light cardio, Dynamic stretches</td>
                <td>-</td>
                <td>5-10 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Bench Press</td>
                <td>3</td>
                <td>8-12</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Bent-Over Rows</td>
                <td>3</td>
                <td>8-12</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Overhead Dumbbell Press</td>
                <td>3</td>
                <td>8-12</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Pull-Ups or Lat Pulldowns</td>
                <td>3</td>
                <td>8-12</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Tricep Dips</td>
                <td>3</td>
                <td>8-12</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Bicep Curls</td>
                <td>3</td>
                <td>8-12</td>
                <td>60-90 secs</td>
            </tr>
        </tbody>
    </table>

    <!-- Day 2 -->
    <h3>Day 2: Lower Body (Superset Push and Pull for Legs)</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (5-10 minutes)</strong></td>
            </tr>
            <tr>
                <td>Light cardio, Dynamic stretches</td>
                <td>-</td>
                <td>5-10 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Squats</td>
                <td>3</td>
                <td>8-12</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Romanian Deadlifts</td>
                <td>3</td>
                <td>8-12</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Leg Press</td>
                <td>3</td>
                <td>8-12</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Leg Curls</td>
                <td>3</td>
                <td>8-12</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Calf Raises</td>
                <td>3</td>
                <td>10-15</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Walking Lunges</td>
                <td>3</td>
                <td>8-12 per leg</td>
                <td>60-90 secs</td>
            </tr>
        </tbody>
    </table>

    <!-- Day 3 -->
    <h3>Day 3: Full Body (Mixed Supersets)</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (5-10 minutes)</strong></td>
            </tr>
            <tr>
                <td>Light cardio, Dynamic stretches</td>
                <td>-</td>
                <td>5-10 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Incline Dumbbell Press</td>
                <td>3</td>
                <td>8-12</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Seated Cable Rows</td>
                <td>3</td>
                <td>8-12</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Lateral Raises</td>
                <td>3</td>
                <td>8-12</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Face Pulls</td>
                <td>3</td>
                <td>8-12</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Plank</td>
                <td>3</td>
                <td>30-60 seconds</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Leg Raises</td>
                <td>3</td>
                <td>12-15</td>
                <td>60-90 secs</td>
            </tr>
        </tbody>
    </table>

    <h3>Additional Notes</h3>
    <ul>
        <li><strong>Progressive Overload:</strong> Gradually increase weights as you become stronger while maintaining proper form.</li>
        <li><strong>Rest Days:</strong> Ensure at least one day of rest between workouts for recovery.</li>
        <li><strong>Cool Down:</strong> End each session with static stretching to improve flexibility and reduce muscle soreness.</li>
    </ul>
</div>

    
    `,

    dropset: 
    `
    <div class="workout-program">
    <h2>Beginner Drop Sets with Mike Mentzer Method (3 Days a Week)</h2>

    <!-- Day 1 -->
    <h3>Day 1: Upper Body (Drop Sets)</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (5-10 minutes)</strong></td>
            </tr>
            <tr>
                <td>Light cardio, Dynamic stretches</td>
                <td>-</td>
                <td>5-10 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Bench Press (Drop Set)</td>
                <td>2</td>
                <td>8-10, then 6-8</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Incline Dumbbell Press (Drop Set)</td>
                <td>2</td>
                <td>8-10, then 6-8</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Bent-Over Rows (Drop Set)</td>
                <td>2</td>
                <td>8-10, then 6-8</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Overhead Dumbbell Press (Drop Set)</td>
                <td>2</td>
                <td>8-10, then 6-8</td>
                <td>60-90 secs</td>
            </tr>
        </tbody>
    </table>

    <!-- Day 2 -->
    <h3>Day 2: Lower Body (Drop Sets)</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (5-10 minutes)</strong></td>
            </tr>
            <tr>
                <td>Light cardio, Dynamic stretches</td>
                <td>-</td>
                <td>5-10 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Squats (Drop Set)</td>
                <td>2</td>
                <td>8-10, then 6-8</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Deadlifts (Drop Set)</td>
                <td>2</td>
                <td>8-10, then 6-8</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Leg Press (Drop Set)</td>
                <td>2</td>
                <td>8-10, then 6-8</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Calf Raises (Drop Set)</td>
                <td>2</td>
                <td>10-12, then 8-10</td>
                <td>60-90 secs</td>
            </tr>
        </tbody>
    </table>

    <!-- Day 3 -->
    <h3>Day 3: Full Body (Drop Sets)</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (5-10 minutes)</strong></td>
            </tr>
            <tr>
                <td>Light cardio, Dynamic stretches</td>
                <td>-</td>
                <td>5-10 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Incline Dumbbell Press (Drop Set)</td>
                <td>2</td>
                <td>8-10, then 6-8</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Pull-Ups or Lat Pulldowns (Drop Set)</td>
                <td>2</td>
                <td>8-10, then 6-8</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Leg Curls (Drop Set)</td>
                <td>2</td>
                <td>8-10, then 6-8</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Bicep Curls (Drop Set)</td>
                <td>2</td>
                <td>8-10, then 6-8</td>
                <td>60-90 secs</td>
            </tr>
        </tbody>
    </table>

    <h3>Additional Notes</h3>
    <ul>
        <li><strong>Progressive Overload:</strong> Gradually increase weights as you become stronger while maintaining proper form.</li>
        <li><strong>Rest Days:</strong> Ensure at least one day of rest between workouts for recovery.</li>
        <li><strong>Cool Down:</strong> End each session with static stretching to improve flexibility and reduce muscle soreness.</li>
    </ul>
</div>

    
    `,

    giantset: 
    `
    <div class="workout-program">
    <h2>Beginner Giant Sets with Mike Mentzer Method (3 Days a Week)</h2>

    <!-- Day 1 -->
    <h3>Day 1: Chest and Triceps (Giant Sets)</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (5-10 minutes)</strong></td>
            </tr>
            <tr>
                <td>Light cardio, Dynamic stretches</td>
                <td>-</td>
                <td>5-10 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Bench Press (Giant Set)</td>
                <td>1</td>
                <td>8-10</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Incline Dumbbell Press (Giant Set)</td>
                <td>1</td>
                <td>8-10</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Chest Flyes (Giant Set)</td>
                <td>1</td>
                <td>8-10</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Push-Ups (Giant Set)</td>
                <td>1</td>
                <td>8-12 (to failure)</td>
                <td>60-90 secs</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Triceps Giant Set</strong></td>
            </tr>
            <tr>
                <td>Tricep Dips</td>
                <td>1</td>
                <td>8-10</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Skull Crushers</td>
                <td>1</td>
                <td>8-10</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Overhead Tricep Extension</td>
                <td>1</td>
                <td>8-10</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Cable Tricep Pushdowns</td>
                <td>1</td>
                <td>8-10</td>
                <td>60-90 secs</td>
            </tr>
        </tbody>
    </table>

    <!-- Day 2 -->
    <h3>Day 2: Back and Biceps (Giant Sets)</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (5-10 minutes)</strong></td>
            </tr>
            <tr>
                <td>Light cardio, Dynamic stretches</td>
                <td>-</td>
                <td>5-10 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Pull-Ups or Lat Pulldowns (Giant Set)</td>
                <td>1</td>
                <td>8-10</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Bent-Over Rows (Giant Set)</td>
                <td>1</td>
                <td>8-10</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Seated Cable Rows (Giant Set)</td>
                <td>1</td>
                <td>8-10</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Dumbbell Shrugs (Giant Set)</td>
                <td>1</td>
                <td>8-10</td>
                <td>60-90 secs</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Biceps Giant Set</strong></td>
            </tr>
            <tr>
                <td>Bicep Curls</td>
                <td>1</td>
                <td>8-10</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Hammer Curls</td>
                <td>1</td>
                <td>8-10</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Concentration Curls</td>
                <td>1</td>
                <td>8-10</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Cable Bicep Curls</td>
                <td>1</td>
                <td>8-10</td>
                <td>60-90 secs</td>
            </tr>
        </tbody>
    </table>

    <!-- Day 3 -->
    <h3>Day 3: Legs and Shoulders (Giant Sets)</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (5-10 minutes)</strong></td>
            </tr>
            <tr>
                <td>Light cardio, Dynamic stretches</td>
                <td>-</td>
                <td>5-10 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Squats (Giant Set)</td>
                <td>1</td>
                <td>8-10</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Leg Press (Giant Set)</td>
                <td>1</td>
                <td>8-10</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Lunges (Giant Set)</td>
                <td>1</td>
                <td>8-10 (per leg)</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Calf Raises (Giant Set)</td>
                <td>1</td>
                <td>10-12</td>
                <td>60-90 secs</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Shoulders Giant Set</strong></td>
            </tr>
            <tr>
                <td>Overhead Dumbbell Press</td>
                <td>1</td>
                <td>8-10</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Lateral Raises</td>
                <td>1</td>
                <td>8-10</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Front Raises</td>
                <td>1</td>
                <td>8-10</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Face Pulls</td>
                <td>1</td>
                <td>8-10</td>
                <td>60-90 secs</td>
            </tr>
        </tbody>
    </table>

    <h3>Additional Notes</h3>
    <ul>
        <li><strong>Progressive Overload:</strong> Gradually increase weights as you become stronger while maintaining proper form.</li>
        <li><strong>Rest Days:</strong> Ensure at least one day of rest between workouts for recovery.</li>
        <li><strong>Cool Down:</strong> End each session with static stretching to improve flexibility and reduce muscle soreness.</li>
    </ul>
</div>

    
    `,

    restpause: 
    `
    <div class="workout-program">
    <h2>Beginner Rest-Pause Training with Mike Mentzer Method (3 Days a Week)</h2>

    <!-- Day 1 -->
    <h3>Day 1: Chest and Triceps (Rest-Pause Method)</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (5-10 minutes)</strong></td>
            </tr>
            <tr>
                <td>Light cardio, Dynamic stretches</td>
                <td>-</td>
                <td>5-10 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Bench Press</td>
                <td>3</td>
                <td>8-10 (to failure + 3-4)</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Incline Dumbbell Press</td>
                <td>3</td>
                <td>8-10 (to failure + 3-4)</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Tricep Dips</td>
                <td>3</td>
                <td>8-10 (to failure + 3-4)</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Skull Crushers</td>
                <td>3</td>
                <td>8-10 (to failure + 3-4)</td>
                <td>60-90 secs</td>
            </tr>
        </tbody>
    </table>

    <!-- Day 2 -->
    <h3>Day 2: Back and Biceps (Rest-Pause Method)</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (5-10 minutes)</strong></td>
            </tr>
            <tr>
                <td>Light cardio, Dynamic stretches</td>
                <td>-</td>
                <td>5-10 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Pull-Ups or Lat Pulldowns</td>
                <td>3</td>
                <td>8-10 (to failure + 3-4)</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Bent-Over Rows</td>
                <td>3</td>
                <td>8-10 (to failure + 3-4)</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Bicep Curls</td>
                <td>3</td>
                <td>8-10 (to failure + 3-4)</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Hammer Curls</td>
                <td>3</td>
                <td>8-10 (to failure + 3-4)</td>
                <td>60-90 secs</td>
            </tr>
        </tbody>
    </table>

    <!-- Day 3 -->
    <h3>Day 3: Legs and Shoulders (Rest-Pause Method)</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (5-10 minutes)</strong></td>
            </tr>
            <tr>
                <td>Light cardio, Dynamic stretches</td>
                <td>-</td>
                <td>5-10 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Squats</td>
                <td>3</td>
                <td>8-10 (to failure + 3-4)</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Leg Press</td>
                <td>3</td>
                <td>8-10 (to failure + 3-4)</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Overhead Dumbbell Press</td>
                <td>3</td>
                <td>8-10 (to failure + 3-4)</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Lateral Raises</td>
                <td>3</td>
                <td>8-10 (to failure + 3-4)</td>
                <td>60-90 secs</td>
            </tr>
        </tbody>
    </table>

    <h3>Additional Notes</h3>
    <ul>
        <li><strong>Progressive Overload:</strong> Gradually increase weights as you become stronger while maintaining proper form.</li>
        <li><strong>Rest Days:</strong> Ensure at least one day of rest between workouts for recovery.</li>
        <li><strong>Cool Down:</strong> End each session with static stretching to improve flexibility and reduce muscle soreness.</li>
    </ul>
</div>

    
    `,

    hit: `

    <div class="workout-program">
    <h2>Beginner High-Intensity Training (HIT) with Mike Mentzer Method (3 Days a Week)</h2>

    <!-- Day 1 -->
    <h3>Day 1: Chest and Back (HIT Style)</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (5-10 minutes)</strong></td>
            </tr>
            <tr>
                <td>Light cardio, Dynamic stretches</td>
                <td>-</td>
                <td>5-10 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Bench Press</td>
                <td>1</td>
                <td>8-10 (to failure)</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Incline Dumbbell Press</td>
                <td>1</td>
                <td>8-10 (to failure)</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Pull-Ups or Lat Pulldowns</td>
                <td>1</td>
                <td>8-10 (to failure)</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Bent-Over Rows</td>
                <td>1</td>
                <td>8-10 (to failure)</td>
                <td>60-90 secs</td>
            </tr>
        </tbody>
    </table>

    <!-- Day 2 -->
    <h3>Day 2: Legs (HIT Style)</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (5-10 minutes)</strong></td>
            </tr>
            <tr>
                <td>Light cardio, Dynamic stretches</td>
                <td>-</td>
                <td>5-10 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Squats</td>
                <td>1</td>
                <td>8-10 (to failure)</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Leg Press</td>
                <td>1</td>
                <td>8-10 (to failure)</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Romanian Deadlifts</td>
                <td>1</td>
                <td>8-10 (to failure)</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Calf Raises</td>
                <td>1</td>
                <td>10-12 (to failure)</td>
                <td>60-90 secs</td>
            </tr>
        </tbody>
    </table>

    <!-- Day 3 -->
    <h3>Day 3: Shoulders and Arms (HIT Style)</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (5-10 minutes)</strong></td>
            </tr>
            <tr>
                <td>Light cardio, Dynamic stretches</td>
                <td>-</td>
                <td>5-10 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Overhead Dumbbell Press</td>
                <td>1</td>
                <td>8-10 (to failure)</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Lateral Raises</td>
                <td>1</td>
                <td>8-10 (to failure)</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Bicep Curls</td>
                <td>1</td>
                <td>8-10 (to failure)</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Tricep Dips</td>
                <td>1</td>
                <td>8-10 (to failure)</td>
                <td>60-90 secs</td>
            </tr>
        </tbody>
    </table>

    <h3>Additional Notes</h3>
    <ul>
        <li><strong>Focus on Intensity:</strong> Each exercise is performed to failure, meaning you cannot perform another rep with proper form.</li>
        <li><strong>Minimal Sets:</strong> High-Intensity Training (HIT) focuses on fewer sets but maximal effort. Push each set to the limit.</li>
        <li><strong>Rest Days:</strong> Ensure at least one day of rest between workouts to recover fully.</li>
        <li><strong>Cool Down:</strong> End each session with static stretching to improve flexibility and reduce muscle soreness.</li>
        <li><strong>Progression:</strong> As you get stronger, increase the weight slightly while maintaining proper form and continuing to push each set to failure.</li>
    </ul>
</div>

    
    `,

    periodization: 
    `
    
    <div class="workout-program">
    <h2>Beginner Periodization with Mike Mentzer Method (4 Phases)</h2>

    <!-- Phase 1: Hypertrophy -->
    <h3>Phase 1: Hypertrophy (Weeks 1-4)</h3>
    <h4>Training Frequency: 3 Days a Week</h4>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Day</th>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="5"><strong>Day 1: Chest and Back</strong></td>
            </tr>
            <tr>
                <td></td>
                <td>Bench Press</td>
                <td>3-4</td>
                <td>8-12</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Incline Dumbbell Press</td>
                <td>3-4</td>
                <td>8-12</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Pull-Ups or Lat Pulldowns</td>
                <td>3-4</td>
                <td>8-12</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Bent-Over Rows</td>
                <td>3-4</td>
                <td>8-12</td>
                <td>60-90 secs</td>
            </tr>
            <tr class="section-header">
                <td colspan="5"><strong>Day 2: Legs</strong></td>
            </tr>
            <tr>
                <td></td>
                <td>Squats</td>
                <td>3-4</td>
                <td>8-12</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Leg Press</td>
                <td>3-4</td>
                <td>8-12</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Romanian Deadlifts</td>
                <td>3-4</td>
                <td>8-12</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Calf Raises</td>
                <td>3-4</td>
                <td>10-15</td>
                <td>60-90 secs</td>
            </tr>
            <tr class="section-header">
                <td colspan="5"><strong>Day 3: Shoulders and Arms</strong></td>
            </tr>
            <tr>
                <td></td>
                <td>Overhead Dumbbell Press</td>
                <td>3-4</td>
                <td>8-12</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Lateral Raises</td>
                <td>3-4</td>
                <td>8-12</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Bicep Curls</td>
                <td>3-4</td>
                <td>8-12</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Tricep Dips</td>
                <td>3-4</td>
                <td>8-12</td>
                <td>60-90 secs</td>
            </tr>
        </tbody>
    </table>

    <!-- Phase 2: Strength -->
    <h3>Phase 2: Strength (Weeks 5-8)</h3>
    <h4>Training Frequency: 3 Days a Week</h4>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Day</th>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="5"><strong>Day 1: Chest and Back</strong></td>
            </tr>
            <tr>
                <td></td>
                <td>Bench Press</td>
                <td>3-5</td>
                <td>4-6</td>
                <td>90-120 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Incline Dumbbell Press</td>
                <td>3-5</td>
                <td>4-6</td>
                <td>90-120 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Pull-Ups or Lat Pulldowns</td>
                <td>3-5</td>
                <td>4-6</td>
                <td>90-120 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Bent-Over Rows</td>
                <td>3-5</td>
                <td>4-6</td>
                <td>90-120 secs</td>
            </tr>
            <tr class="section-header">
                <td colspan="5"><strong>Day 2: Legs</strong></td>
            </tr>
            <tr>
                <td></td>
                <td>Squats</td>
                <td>3-5</td>
                <td>4-6</td>
                <td>90-120 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Deadlifts</td>
                <td>3-5</td>
                <td>4-6</td>
                <td>90-120 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Leg Press</td>
                <td>3-5</td>
                <td>4-6</td>
                <td>90-120 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Calf Raises</td>
                <td>3-5</td>
                <td>8-10</td>
                <td>90-120 secs</td>
            </tr>
            <tr class="section-header">
                <td colspan="5"><strong>Day 3: Shoulders and Arms</strong></td>
            </tr>
            <tr>
                <td></td>
                <td>Overhead Dumbbell Press</td>
                <td>3-5</td>
                <td>4-6</td>
                <td>90-120 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Lateral Raises</td>
                <td>3-5</td>
                <td>4-6</td>
                <td>90-120 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Bicep Curls</td>
                <td>3-5</td>
                <td>4-6</td>
                <td>90-120 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Tricep Dips</td>
                <td>3-5</td>
                <td>4-6</td>
                <td>90-120 secs</td>
            </tr>
        </tbody>
    </table>

    <!-- Phase 3: Power and Peaking -->
    <h3>Phase 3: Power and Peaking (Weeks 9-12)</h3>
    <h4>Training Frequency: 3 Days a Week</h4>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Day</th>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="5"><strong>Day 1: Chest and Back</strong></td>
            </tr>
            <tr>
                <td></td>
                <td>Bench Press (Explosive)</td>
                <td>3-4</td>
                <td>2-4</td>
                <td>120 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Incline Dumbbell Press</td>
                <td>3-4</td>
                <td>2-4</td>
                <td>120 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Pull-Ups or Lat Pulldowns</td>
                <td>3-4</td>
                <td>2-4</td>
                <td>120 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Bent-Over Rows</td>
                <td>3-4</td>
                <td>2-4</td>
                <td>120 secs</td>
            </tr>
            <tr class="section-header">
                <td colspan="5"><strong>Day 2: Legs</strong></td>
            </tr>
            <tr>
                <td></td>
                <td>Squats (Explosive)</td>
                <td>3-4</td>
                <td>2-4</td>
                <td>120 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Deadlifts (Explosive)</td>
                <td>3-4</td>
                <td>2-4</td>
                <td>120 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Leg Press</td>
                <td>3-4</td>
                <td>2-4</td>
                <td>120 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Calf Raises</td>
                <td>3-4</td>
                <td>6-8</td>
                <td>120 secs</td>
            </tr>
            <tr class="section-header">
                <td colspan="5"><strong>Day 3: Shoulders and Arms</strong></td>
            </tr>
            <tr>
                <td></td>
                <td>Overhead Dumbbell Press (Explosive)</td>
                <td>3-4</td>
                <td>2-4</td>
                <td>120 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Lateral Raises</td>
                <td>3-4</td>
                <td>2-4</td>
                <td>120 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Bicep Curls</td>
                <td>3-4</td>
                <td>2-4</td>
                <td>120 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Tricep Dips</td>
                <td>3-4</td>
                <td>2-4</td>
                <td>120 secs</td>
            </tr>
        </tbody>
    </table>

    <!-- Phase 4: Active Recovery -->
    <h3>Phase 4: Active Recovery (Weeks 13-16)</h3>
    <h4>Training Frequency: 3 Days a Week</h4>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Day</th>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="5"><strong>Day 1: Full Body</strong></td>
            </tr>
            <tr>
                <td></td>
                <td>Bodyweight Squats</td>
                <td>2-3</td>
                <td>10-15</td>
                <td>30-60 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Push-Ups</td>
                <td>2-3</td>
                <td>10-15</td>
                <td>30-60 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Plank</td>
                <td>2-3</td>
                <td>30-60 secs</td>
                <td>30-60 secs</td>
            </tr>
            <tr class="section-header">
                <td colspan="5"><strong>Day 2: Cardio and Mobility</strong></td>
            </tr>
            <tr>
                <td></td>
                <td>Brisk Walking or Light Jogging</td>
                <td>1</td>
                <td>30 mins</td>
                <td></td>
            </tr>
            <tr>
                <td></td>
                <td>Dynamic Stretching</td>
                <td>1</td>
                <td>15 mins</td>
                <td></td>
            </tr>
            <tr class="section-header">
                <td colspan="5"><strong>Day 3: Core and Flexibility</strong></td>
            </tr>
            <tr>
                <td></td>
                <td>Leg Raises</td>
                <td>2-3</td>
                <td>10-15</td>
                <td>30-60 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Russian Twists</td>
                <td>2-3</td>
                <td>10-15</td>
                <td>30-60 secs</td>
            </tr>
            <tr>
                <td></td>
                <td>Static Stretching</td>
                <td>1</td>
                <td>15 mins</td>
                <td></td>
            </tr>
        </tbody>
    </table>
</div>

    
    `,

    functional: 
    `
    
    <div class="workout-program">
    <h2>Beginner Bodybuilding with Functional Training and Mike Mentzer Method (3 Days a Week)</h2>

    <!-- Day 1 -->
    <h3>Day 1: Chest, Back, and Functional Core (Functional and Hypertrophy Focus)</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (5-10 minutes)</strong></td>
            </tr>
            <tr>
                <td>Light cardio, Dynamic stretches</td>
                <td>-</td>
                <td>5-10 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Bench Press</td>
                <td>3</td>
                <td>8-10</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Pull-Ups or Lat Pulldowns</td>
                <td>3</td>
                <td>8-10</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Kettlebell Swings</td>
                <td>3</td>
                <td>12-15</td>
                <td>60 secs</td>
            </tr>
            <tr>
                <td>Medicine Ball Slams</td>
                <td>3</td>
                <td>10-12</td>
                <td>60 secs</td>
            </tr>
        </tbody>
    </table>

    <!-- Day 2 -->
    <h3>Day 2: Legs, Shoulders, and Mobility (Functional and Strength Focus)</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (5-10 minutes)</strong></td>
            </tr>
            <tr>
                <td>Light cardio, Dynamic stretches</td>
                <td>-</td>
                <td>5-10 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Squats</td>
                <td>3</td>
                <td>8-10</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Overhead Dumbbell Press</td>
                <td>3</td>
                <td>8-10</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Lunges</td>
                <td>3</td>
                <td>12-15 (per leg)</td>
                <td>60 secs</td>
            </tr>
            <tr>
                <td>Turkish Get-Up</td>
                <td>3</td>
                <td>5-6 (per side)</td>
                <td>60-90 secs</td>
            </tr>
        </tbody>
    </table>

    <!-- Day 3 -->
    <h3>Day 3: Full-Body Functional Conditioning and Arms (Functional and Endurance Focus)</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (5-10 minutes)</strong></td>
            </tr>
            <tr>
                <td>Light cardio, Dynamic stretches</td>
                <td>-</td>
                <td>5-10 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Deadlifts</td>
                <td>3</td>
                <td>6-8</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Bicep Curls</td>
                <td>3</td>
                <td>8-10</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Tricep Dips</td>
                <td>3</td>
                <td>8-10</td>
                <td>60-90 secs</td>
            </tr>
            <tr>
                <td>Box Jumps</td>
                <td>3</td>
                <td>10</td>
                <td>60 secs</td>
            </tr>
            <tr>
                <td>Plank</td>
                <td>3</td>
                <td>30-45 secs</td>
                <td>-</td>
            </tr>
        </tbody>
    </table>

    <h3>Additional Notes</h3>
    <ul>
        <li><strong>Warm-Up:</strong> Begin each session with 5-10 minutes of light cardio and dynamic stretches to activate muscles and joints.</li>
        <li><strong>Functional Focus:</strong> Incorporate functional movements to enhance real-world performance, balance, and coordination while maintaining muscle-building efforts.</li>
        <li><strong>Rest Days:</strong> Ensure rest days between workouts to allow proper recovery and muscle growth.</li>
        <li><strong>Cool Down:</strong> Finish each workout with static stretching, focusing on flexibility and recovery.</li>
        <li><strong>Progression:</strong> Gradually increase weights or reps for bodybuilding exercises and challenge your balance, coordination, and mobility for functional movements as you progress.</li>
    </ul>
</div>

    
    `
  },

  // intermediate: {
  //   traditional: `...your intermediate traditional plan...`,
  //   split: `...your intermediate split plan...`,
  //   // ... other intermediate plans
  // },
  calisthenics: {
    muscleup: `
      <div class="workout-program">
        <h2>Muscle-Up Beginner Workout Plan (3 Days a Week)</h2>

        <h3>Day 1: Pulling Strength & Grip</h3>
        <table class="workout-table">
          <thead>
            <tr>
              <th>Exercise</th>
              <th>Sets</th>
              <th>Reps/Time</th>
              <th>Rest</th>
            </tr>
          </thead>
          <tbody>
            <tr class="section-header">
              <td colspan="4"><strong>Warm-up (10-15 minutes)</strong></td>
            </tr>
            <tr>
              <td>Jump rope, dynamic stretches, and arm circles</td>
              <td>-</td>
              <td>10-15 mins</td>
              <td>-</td>
            </tr>

            <tr class="section-header">
              <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
              <td>Dead Hangs (Grip Strength)</td>
              <td>4</td>
              <td>Max Time</td>
              <td>1-2 mins</td>
            </tr>
            <tr>
              <td>Assisted Pull-Ups</td>
              <td>4</td>
              <td>6-8</td>
              <td>2 mins</td>
            </tr>
            <tr>
              <td>Australian Pull-Ups</td>
              <td>3</td>
              <td>10-12</td>
              <td>1-2 mins</td>
            </tr>
            <tr>
              <td>Negative Pull-Ups</td>
              <td>3</td>
              <td>5-6</td>
              <td>2 mins</td>
            </tr>
            <tr>
              <td>Barbell/Dumbbell Curls</td>
              <td>3</td>
              <td>10-12</td>
              <td>1-2 mins</td>
            </tr>

            <tr class="section-header">
              <td colspan="4"><strong>Core Finisher</strong></td>
            </tr>
            <tr>
              <td>Plank</td>
              <td>3</td>
              <td>45-60 secs</td>
              <td>1 min</td>
            </tr>
          </tbody>
        </table>

        <h3>Day 2: Upper Body Power & Technique</h3>
        <table class="workout-table">
          <thead>
            <tr>
              <th>Exercise</th>
              <th>Sets</th>
              <th>Reps/Time</th>
              <th>Rest</th>
            </tr>
          </thead>
          <tbody>
            <tr class="section-header">
              <td colspan="4"><strong>Warm-up (10-15 minutes)</strong></td>
            </tr>
            <tr>
              <td>Jump rope, dynamic stretches, shoulder mobility drills</td>
              <td>-</td>
              <td>10-15 mins</td>
              <td>-</td>
            </tr>

            <tr class="section-header">
              <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
              <td>Explosive Push-Ups</td>
              <td>4</td>
              <td>8-10</td>
              <td>1-2 mins</td>
            </tr>
            <tr>
              <td>Dips</td>
              <td>3</td>
              <td>8-10</td>
              <td>2 mins</td>
            </tr>
            <tr>
              <td>Band-Assisted Muscle-Up Transitions</td>
              <td>3</td>
              <td>4-6</td>
              <td>2 mins</td>
            </tr>
            <tr>
              <td>Ring Rows</td>
              <td>3</td>
              <td>10-12</td>
              <td>1-2 mins</td>
            </tr>
            <tr>
              <td>Shoulder Press</td>
              <td>3</td>
              <td>8-10</td>
              <td>1-2 mins</td>
            </tr>

            <tr class="section-header">
              <td colspan="4"><strong>Core Finisher</strong></td>
            </tr>
            <tr>
              <td>Hanging Leg Raises</td>
              <td>3</td>
              <td>10-12</td>
              <td>1 min</td>
            </tr>
          </tbody>
        </table>

        <h3>Day 3: Pulling Strength & Core Focus</h3>
<table class="workout-table">
  <thead>
    <tr>
      <th>Exercise</th>
      <th>Sets</th>
      <th>Reps/Time</th>
      <th>Rest</th>
    </tr>
  </thead>
  <tbody>
    <tr class="section-header">
      <td colspan="4"><strong>Warm-up (10-15 minutes)</strong></td>
    </tr>
    <tr>
      <td>Dynamic stretches, scapular mobility drills, light jogging</td>
      <td>-</td>
      <td>10-15 mins</td>
      <td>-</td>
    </tr>

    <tr class="section-header">
      <td colspan="4"><strong>Main Workout</strong></td>
    </tr>
    <tr>
      <td>Pull-Up Progression (Assisted or Standard)</td>
      <td>5</td>
      <td>5-6</td>
      <td>2 mins</td>
    </tr>
    <tr>
      <td>Chest-to-Bar Pull-Ups</td>
      <td>4</td>
      <td>4-6</td>
      <td>2 mins</td>
    </tr>
    <tr>
      <td>Chin-Ups</td>
      <td>4</td>
      <td>6-8</td>
      <td>2 mins</td>
    </tr>
    <tr>
      <td>L-Sit on Bars</td>
      <td>3</td>
      <td>Max hold (15-30 secs)</td>
      <td>1-2 mins</td>
    </tr>
    <tr>
      <td>Bicep Curls (Hammer Curl or Traditional)</td>
      <td>3</td>
      <td>10-12</td>
      <td>1-2 mins</td>
    </tr>

    <tr class="section-header">
      <td colspan="4"><strong>Core Finisher</strong></td>
    </tr>
    <tr>
      <td>Russian Twists</td>
      <td>3</td>
      <td>20-30 twists</td>
      <td>1 min</td>
    </tr>
  </tbody>
</table>

<h3>Alternative Workouts for Beginners</h3>
<table class="workout-table">
  <thead>
    <tr>
      <th>Exercise</th>
      <th>Sets</th>
      <th>Reps/Time</th>
      <th>Rest</th>
    </tr>
  </thead>
  <tbody>
    <tr class="section-header">
      <td colspan="4"><strong>Alternative for Chin-Ups & Pull-Ups</strong></td>
    </tr>
    <tr>
      <td>Inverted Rows (Australian Pull-Ups)</td>
      <td>4</td>
      <td>10-12</td>
      <td>1-2 mins</td>
    </tr>
    <tr>
      <td>Assisted Pull-Ups with Resistance Bands</td>
      <td>4</td>
      <td>5-8</td>
      <td>2 mins</td>
    </tr>
    <tr>
      <td>Negative Chin-Ups</td>
      <td>4</td>
      <td>5</td>
      <td>2 mins</td>
    </tr>

    <tr class="section-header">
      <td colspan="4"><strong>Alternative for Dips</strong></td>
    </tr>
    <tr>
      <td>Bench Dips</td>
      <td>4</td>
      <td>10-12</td>
      <td>1-2 mins</td>
    </tr>
    <tr>
      <td>Push-Ups (Focus on Triceps)</td>
      <td>3</td>
      <td>12-15</td>
      <td>1-2 mins</td>
    </tr>

    <tr class="section-header">
      <td colspan="4"><strong>Alternative for L-Sit</strong></td>
    </tr>
    <tr>
      <td>Tucked Hold</td>
      <td>3</td>
      <td>10-15 secs</td>
      <td>1-2 mins</td>
    </tr>
    <tr>
      <td>Plank to L-Sit Progression</td>
      <td>3</td>
      <td>30-60 secs hold</td>
      <td>1 min</td>
    </tr>

    <tr class="section-header">
      <td colspan="4"><strong>Alternative for Barbell/Dumbbell Curls</strong></td>
    </tr>
    <tr>
      <td>Resistance Band Curls</td>
      <td>3</td>
      <td>12-15</td>
      <td>1-2 mins</td>
    </tr>

    <tr class="section-header">
      <td colspan="4"><strong>Alternative for Hanging Leg Raises</strong></td>
    </tr>
    <tr>
      <td>Lying Leg Raises</td>
      <td>3</td>
      <td>10-12</td>
      <td>1-2 mins</td>
    </tr>
    <tr>
      <td>Reverse Crunches</td>
      <td>3</td>
      <td>10-12</td>
      <td>1-2 mins</td>
    </tr>

    <tr class="section-header">
      <td colspan="4"><strong>Alternative for Shoulder Press</strong></td>
    </tr>
    <tr>
      <td>Pike Push-Ups</td>
      <td>3</td>
      <td>8-10</td>
      <td>1-2 mins</td>
    </tr>
  </tbody>
</table>

        <!-- Similar tables for Day 3 and Alternative Workouts -->
      </div>
    `,


    handstand: `
    
    <div class="workout-program">
    <h2>Handstand Workout Plan (3 Days a Week)</h2>

    <h3>Day 1: Shoulder Strength & Core Stability</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps/Time</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (10-15 minutes)</strong></td>
            </tr>
            <tr>
                <td>Wrist stretches and rotations, Shoulder dislocates with band, Arm circles, Cat-cow stretches</td>
                <td>-</td>
                <td>10-15 mins</td>
                <td>-</td>
            </tr>

            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Wall Walks</td>
                <td>4</td>
                <td>5-6 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Pike Push-Ups</td>
                <td>4</td>
                <td>8-10 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Plank to Downward Dog</td>
                <td>3</td>
                <td>10-12 reps</td>
                <td>1 min</td>
            </tr>
            <tr>
                <td>Shoulder Taps (in Plank or Elevated Position)</td>
                <td>4</td>
                <td>12-16 reps</td>
                <td>1 min</td>
            </tr>
            <tr>
                <td>Hollow Body Hold</td>
                <td>3</td>
                <td>20-30 secs</td>
                <td>1 min</td>
            </tr>
        </tbody>
    </table>

    <h3>Day 2: Handstand Skill Practice & Mobility</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps/Time</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (10-15 minutes)</strong></td>
            </tr>
            <tr>
                <td>Wrist mobility, Dynamic shoulder stretches, Wall shoulder stretches</td>
                <td>-</td>
                <td>10-15 mins</td>
                <td>-</td>
            </tr>

            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Wall Handstand Hold</td>
                <td>4</td>
                <td>20-30 secs</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Handstand Kick-Ups (against the wall)</td>
                <td>4</td>
                <td>5-6 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Box Pike Hold</td>
                <td>3</td>
                <td>20-30 secs</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Lateral Wall Walks</td>
                <td>3</td>
                <td>3-4 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Seated Shoulder Compression Drills</td>
                <td>3</td>
                <td>10-12 reps</td>
                <td>1 min</td>
            </tr>

            <tr class="section-header">
                <td colspan="4"><strong>Mobility Focus</strong></td>
            </tr>
            <tr>
                <td>Thoracic Extensions, Shoulder Dislocates, Wrist Flexibility Drills</td>
                <td>-</td>
                <td>3 sets of 10 reps/30-45 secs</td>
                <td>-</td>
            </tr>
        </tbody>
    </table>

    <h3>Day 3: Balance, Core, and Conditioning</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps/Time</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (10-15 minutes)</strong></td>
            </tr>
            <tr>
                <td>Wrist mobility, Dynamic stretches, Hip mobility</td>
                <td>-</td>
                <td>10-15 mins</td>
                <td>-</td>
            </tr>

            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Freestanding Handstand Attempts</td>
                <td>4</td>
                <td>Max attempts</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Tuck Handstand (against the wall)</td>
                <td>3</td>
                <td>10-15 secs</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Handstand Shoulder Shrugs</td>
                <td>3</td>
                <td>8-10 reps</td>
                <td>1 min</td>
            </tr>
            <tr>
                <td>L-Sit to Handstand Progression</td>
                <td>3</td>
                <td>10-20 secs</td>
                <td>1-2 mins</td>
            </tr>
            
            <tr class="section-header">
                <td colspan="4"><strong>Core Conditioning Circuit</strong></td>
            </tr>
            <tr>
                <td>Hollow Body Rocks, Russian Twists, Plank Hold</td>
                <td>-</td>
                <td>3 rounds of 15-20 reps/30-45 secs</td>
                <td>-</td>
            </tr>

            <tr class="section-header">
                <td colspan="4"><strong>Mobility Focus</strong></td>
            </tr>
            <tr>
                <td>Shoulder Flexion on Wall, Wrist and Finger Stretches</td>
                <td>-</td>
                <td>3 sets of 20-30 secs</td>
                <td>-</td>
            </tr>
        </tbody>
    </table>
</div>
`,

    planche: `
    
    <div class="workout-program">
    <h2>Beginner-Friendly Planche Workout Plan (3 Days a Week)</h2>

    <!-- Day 1 -->
    <h3>Day 1: Foundation Building & Planche Basics</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps/Time</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (10-15 minutes)</strong></td>
            </tr>
            <tr>
                <td>Wrist stretches, Shoulder dislocates, Arm circles, Cat-cow stretches</td>
                <td>-</td>
                <td>10-15 mins</td>
                <td>-</td>
            </tr>

            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Plank Hold</td>
                <td>4</td>
                <td>20-30 secs</td>
                <td>1 min</td>
            </tr>
            <tr>
                <td>Planche Lean (Beginner)</td>
                <td>3</td>
                <td>10-15 secs</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Knee Tuck Planche (On Knees)</td>
                <td>3</td>
                <td>10-15 secs</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Incline Push-Ups</td>
                <td>3</td>
                <td>8-10 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Scapular Push-Ups</td>
                <td>3</td>
                <td>10-12 reps</td>
                <td>1-2 mins</td>
            </tr>

            <tr class="section-header">
                <td colspan="4"><strong>Core Finisher</strong></td>
            </tr>
            <tr>
                <td>Hollow Body Hold (Beginner)</td>
                <td>3</td>
                <td>10-15 secs</td>
                <td>-</td>
            </tr>
        </tbody>
    </table>

    <!-- Day 2 -->
    <h3>Day 2: Planche Progression & Core Strength</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps/Time</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (10-15 minutes)</strong></td>
            </tr>
            <tr>
                <td>Wrist stretches, Shoulder dislocates, Arm rotations</td>
                <td>-</td>
                <td>10-15 mins</td>
                <td>-</td>
            </tr>

            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Plank to Planche Lean (Beginner)</td>
                <td>3</td>
                <td>8-10 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Tuck Planche on Knees (Progression)</td>
                <td>3</td>
                <td>10-20 secs</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Knee Push-Ups</td>
                <td>3</td>
                <td>8-12 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Dips (Use Chair or Bench)</td>
                <td>3</td>
                <td>6-8 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Lying Scapular Retractions</td>
                <td>3</td>
                <td>12 reps</td>
                <td>1 min</td>
            </tr>

            <tr class="section-header">
                <td colspan="4"><strong>Core Finisher</strong></td>
            </tr>
            <tr>
                <td>Tuck-Up Hold</td>
                <td>3</td>
                <td>20 secs</td>
                <td>-</td>
            </tr>
        </tbody>
    </table>

    <!-- Day 3 -->
    <h3>Day 3: Strength & Mobility Focus</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps/Time</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (10-15 minutes)</strong></td>
            </tr>
            <tr>
                <td>Wrist circles, Shoulder mobility drills, Dynamic arm stretches</td>
                <td>-</td>
                <td>10-15 mins</td>
                <td>-</td>
            </tr>

            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Elevated Plank Hold</td>
                <td>3</td>
                <td>20-30 secs</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Wall Planche Leans (Beginner)</td>
                <td>3</td>
                <td>10-15 secs</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Negative Push-Ups</td>
                <td>3</td>
                <td>5-6 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Parallel Bar Support Hold</td>
                <td>3</td>
                <td>20-30 secs</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Pike Hold</td>
                <td>3</td>
                <td>20-30 secs</td>
                <td>1-2 mins</td>
            </tr>

            <tr class="section-header">
                <td colspan="4"><strong>Mobility Finisher</strong></td>
            </tr>
            <tr>
                <td>Wrist Flexibility Drills</td>
                <td>-</td>
                <td>3 sets of 30 secs each</td>
                <td>-</td>
            </tr>
            <tr>
                <td>Shoulder Flexion Stretches</td>
                <td>-</td>
                <td>3 sets of 20-30 secs</td>
                <td>-</td>
            </tr>
        </tbody>
    </table>
</div>


    `,

    frontlever: `
    
    <div class="workout-program">
    <h2>Beginner-Friendly Front Lever Workout Plan (3 Days a Week)</h2>

    <!-- Day 1 -->
    <h3>Day 1: Core & Back Strength</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps/Time</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (10-15 minutes)</strong></td>
            </tr>
            <tr>
                <td>Wrist stretches, Shoulder dislocates, Scapular push-ups, Hollow body hold</td>
                <td>-</td>
                <td>10-15 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Tuck Front Lever Hold (Beginner)</td>
                <td>3</td>
                <td>10-15 secs</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Inverted Rows</td>
                <td>4</td>
                <td>8-10 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Hollow Body Rocks</td>
                <td>3</td>
                <td>20-30 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Negative Pull-Ups</td>
                <td>3</td>
                <td>3-5 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Scapular Pull-Ups</td>
                <td>3</td>
                <td>10 reps</td>
                <td>1 min</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Core Finisher</strong></td>
            </tr>
            <tr>
                <td>Plank Hold</td>
                <td>3</td>
                <td>20-30 secs</td>
                <td>-</td>
            </tr>
        </tbody>
    </table>

    <!-- Day 2 -->
    <h3>Day 2: Shoulder & Core Strength</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps/Time</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (10-15 minutes)</strong></td>
            </tr>
            <tr>
                <td>Shoulder & wrist mobility exercises, Arm circles, Dynamic stretches</td>
                <td>-</td>
                <td>10-15 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Tuck Front Lever Rows</td>
                <td>3</td>
                <td>8-10 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Hanging Leg Raises (Knee Tucks)</td>
                <td>3</td>
                <td>10-12 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Band-Assisted Front Lever Holds</td>
                <td>3</td>
                <td>10-15 secs</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Bodyweight Rows</td>
                <td>4</td>
                <td>10-12 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Pike Push-Ups</td>
                <td>3</td>
                <td>8-10 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Core Finisher</strong></td>
            </tr>
            <tr>
                <td>Tuck L-Sit Hold</td>
                <td>3</td>
                <td>10-15 secs</td>
                <td>-</td>
            </tr>
        </tbody>
    </table>

    <!-- Day 3 -->
    <h3>Day 3: Full Body Strength & Front Lever Progressions</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps/Time</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (10-15 minutes)</strong></td>
            </tr>
            <tr>
                <td>Dynamic stretches, Hollow body holds, Shoulder dislocates</td>
                <td>-</td>
                <td>10-15 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Tuck Front Lever (Advanced)</td>
                <td>4</td>
                <td>10-15 secs</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Pull-Ups (Band-Assisted if Necessary)</td>
                <td>3</td>
                <td>6-8 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Tuck Front Lever to Negative Front Lever</td>
                <td>3</td>
                <td>3-5 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Back Extensions</td>
                <td>3</td>
                <td>10-12 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Isometric Ring Hold</td>
                <td>3</td>
                <td>20-30 secs</td>
                <td>1-2 mins</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Core Finisher</strong></td>
            </tr>
            <tr>
                <td>Hollow Body Hold</td>
                <td>3</td>
                <td>20-30 secs</td>
                <td>-</td>
            </tr>
        </tbody>
    </table>
</div>

    
    `,


    backlever: 
    `
    <div class="workout-program">
    <h2>Beginner-Friendly Back Lever Workout Plan (3 Days a Week)</h2>

    <!-- Day 1 -->
    <h3>Day 1: Core & Back Strength</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps/Time</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (10-15 minutes)</strong></td>
            </tr>
            <tr>
                <td>Wrist stretches, Shoulder dislocates, Dynamic back stretches, Hollow body hold</td>
                <td>-</td>
                <td>10-15 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Tuck Back Lever Hold</td>
                <td>3</td>
                <td>10-15 secs</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Inverted Rows (Under a Bar)</td>
                <td>4</td>
                <td>8-10 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Hollow Body Rocks</td>
                <td>3</td>
                <td>20-30 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Negative Pull-Ups</td>
                <td>3</td>
                <td>3-5 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Scapular Pull-Ups</td>
                <td>3</td>
                <td>10 reps</td>
                <td>1 min</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Core Finisher</strong></td>
            </tr>
            <tr>
                <td>Plank Hold</td>
                <td>3</td>
                <td>20-30 secs</td>
                <td>-</td>
            </tr>
        </tbody>
    </table>

    <!-- Day 2 -->
    <h3>Day 2: Shoulder & Core Stability</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps/Time</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (10-15 minutes)</strong></td>
            </tr>
            <tr>
                <td>Shoulder mobility drills, Arm circles, Dynamic shoulder stretches</td>
                <td>-</td>
                <td>10-15 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Tuck Back Lever Rows</td>
                <td>3</td>
                <td>8-10 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Hanging Leg Raises (Knee Tucks)</td>
                <td>3</td>
                <td>10-12 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Band-Assisted Back Lever Holds</td>
                <td>3</td>
                <td>10-15 secs</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Bodyweight Rows</td>
                <td>4</td>
                <td>10-12 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Pike Push-Ups</td>
                <td>3</td>
                <td>8-10 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Core Finisher</strong></td>
            </tr>
            <tr>
                <td>Tuck L-Sit Hold</td>
                <td>3</td>
                <td>10-15 secs</td>
                <td>-</td>
            </tr>
        </tbody>
    </table>

    <!-- Day 3 -->
    <h3>Day 3: Full Body Strength & Back Lever Progressions</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps/Time</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (10-15 minutes)</strong></td>
            </tr>
            <tr>
                <td>Dynamic stretches for shoulders, back, core; Hollow body hold, Shoulder dislocates</td>
                <td>-</td>
                <td>10-15 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Tuck Back Lever (Advanced)</td>
                <td>4</td>
                <td>10-15 secs</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Pull-Ups (Band-Assisted if Necessary)</td>
                <td>3</td>
                <td>6-8 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Tuck Back Lever to Negative Back Lever</td>
                <td>3</td>
                <td>3-5 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Back Extensions</td>
                <td>3</td>
                <td>10-12 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Isometric Ring Hold</td>
                <td>3</td>
                <td>20-30 secs</td>
                <td>1-2 mins</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Core Finisher</strong></td>
            </tr>
            <tr>
                <td>Hollow Body Hold</td>
                <td>3</td>
                <td>20-30 secs</td>
                <td>-</td>
            </tr>
        </tbody>
    </table>
</div>

    
    `,

    humanflag: 
    `
    <div class="workout-program">
    <h2>Beginner-Friendly Human Flag Workout Plan (3 Days a Week)</h2>

    <!-- Day 1 -->
    <h3>Day 1: Core & Shoulder Strength</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps/Time</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (10-15 minutes)</strong></td>
            </tr>
            <tr>
                <td>Wrist stretches, Shoulder dislocates, Dynamic core stretches, Hollow body hold</td>
                <td>-</td>
                <td>10-15 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Tuck Flag Hold</td>
                <td>3</td>
                <td>10-15 secs</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Inverted Rows (Under a Bar)</td>
                <td>4</td>
                <td>8-10 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Hollow Body Rocks</td>
                <td>3</td>
                <td>20-30 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Negative Pull-Ups</td>
                <td>3</td>
                <td>3-5 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Scapular Pull-Ups</td>
                <td>3</td>
                <td>10 reps</td>
                <td>1 min</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Core Finisher</strong></td>
            </tr>
            <tr>
                <td>Plank Hold</td>
                <td>3</td>
                <td>20-30 secs</td>
                <td>-</td>
            </tr>
        </tbody>
    </table>

    <!-- Day 2 -->
    <h3>Day 2: Side Strength & Stability</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps/Time</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (10-15 minutes)</strong></td>
            </tr>
            <tr>
                <td>Shoulder mobility, Arm circles, Dynamic side stretches</td>
                <td>-</td>
                <td>10-15 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Side Plank (Leg Raises)</td>
                <td>3</td>
                <td>8-10 reps per side</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Hanging Knee Raises</td>
                <td>3</td>
                <td>10-12 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Band-Assisted Human Flag Holds</td>
                <td>3</td>
                <td>10-15 secs</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Bodyweight Rows</td>
                <td>4</td>
                <td>10-12 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Side-to-Side Shuffles</td>
                <td>3</td>
                <td>20 secs</td>
                <td>1-2 mins</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Core Finisher</strong></td>
            </tr>
            <tr>
                <td>Tuck L-Sit Hold</td>
                <td>3</td>
                <td>10-15 secs</td>
                <td>-</td>
            </tr>
        </tbody>
    </table>

    <!-- Day 3 -->
    <h3>Day 3: Full Body Strength & Human Flag Progressions</h3>
    <table class="workout-table">
        <thead>
            <tr>
                <th>Exercise</th>
                <th>Sets</th>
                <th>Reps/Time</th>
                <th>Rest</th>
            </tr>
        </thead>
        <tbody>
            <tr class="section-header">
                <td colspan="4"><strong>Warm-up (10-15 minutes)</strong></td>
            </tr>
            <tr>
                <td>Dynamic stretches for shoulders, Hollow body holds, Shoulder dislocates</td>
                <td>-</td>
                <td>10-15 mins</td>
                <td>-</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Main Workout</strong></td>
            </tr>
            <tr>
                <td>Tuck Flag to Extended Flag</td>
                <td>4</td>
                <td>10-15 secs</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Pull-Ups (Band-Assisted if Necessary)</td>
                <td>3</td>
                <td>6-8 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Tuck Flag to Negative Flag</td>
                <td>3</td>
                <td>3-5 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Back Extensions</td>
                <td>3</td>
                <td>10-12 reps</td>
                <td>1-2 mins</td>
            </tr>
            <tr>
                <td>Isometric Hold on Bar</td>
                <td>3</td>
                <td>20-30 secs</td>
                <td>1-2 mins</td>
            </tr>
            <tr class="section-header">
                <td colspan="4"><strong>Core Finisher</strong></td>
            </tr>
            <tr>
                <td>Hollow Body Hold</td>
                <td>3</td>
                <td>20-30 secs</td>
                <td>-</td>
            </tr>
        </tbody>
    </table>
</div>

    
    `
  }
}; 